import { t } from '../../theme';

/**
 * The shared tile chrome.
 *
 * Every widget is the same card with the same kicker, so the dashboard reads
 * as one board rather than a pile of unrelated panels. Widgets supply only
 * their contents; nothing decides its own background or radius.
 */
export function Widget({
  kicker: label,
  onTap,
  accessory,
  children,
}: {
  kicker: string;
  onTap?: () => void;
  accessory?: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <div
      className={onTap ? 'press' : undefined}
      onClick={onTap}
      style={{
        borderRadius: 28,
        background: t.surfaceRaised,
        boxShadow: 'inset 0 1px 0 oklch(1 0 0 / 0.07), 0 18px 34px -26px oklch(0.05 0 0 / 0.9)',
        padding: '18px 22px 18px',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        minWidth: 0,
        minHeight: 0,
        overflow: 'hidden',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: 12 }}>
        <div
          style={{
            fontFamily: t.mono,
            fontSize: 13,
            letterSpacing: '0.16em',
            color: t.inkFaint,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {label}
        </div>
        {accessory}
      </div>
      <div style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>{children}</div>
    </div>
  );
}

/** Shown inside a widget when there is genuinely nothing to report. */
export function WidgetEmpty({ children }: { children: React.ReactNode }) {
  return (
    <div
      style={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        fontSize: 18,
        color: t.inkFaint,
        textWrap: 'pretty',
        padding: '8px 0',
      }}
    >
      {children}
    </div>
  );
}
